import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core'

import { EntityWithUpload } from './EntityWithUpload'
import { fetchUploadFactory } from './fetchUploadFactory'

export async function handleImageUpload(
  file: File,
  client: ApolloClient<NormalizedCacheObject>,
  entity: EntityWithUpload
): Promise<[string, boolean]> {
  try {
    const fetchUpload = fetchUploadFactory(entity)
    if (!fetchUpload) return ['', true]

    const uploadDetails = await fetchUpload(file, client)

    if (!uploadDetails) return ['', true]
    const { url, fields } = uploadDetails

    let path: string | undefined
    const form = new FormData()
    fields.forEach(({ key, value }) => {
      if (key === 'key') path = value
      form.append(key, value)
    })
    form.append('file', file)
    if (!path) return ['', true]

    await fetch(url, {
      method: 'POST',
      mode: 'no-cors', // TODO remove in production
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      body: form
    })

    return [path, false]
  } catch (e) {
    console.error(e)
    return ['', true]
  }
}
